import {
	ASSOCIATE_USER_LEVEL,
	REGULAR_USER_LEVEL,
} from '@/constants/vuex.type';
import {
	loginUser,
	updateToRegularUserLevel,
	fetchUserFromLoginToken,
} from '@/api';
import { setLoginToken, removeLoginToken } from '@/utils/auth';

const namespaced = true;

const state = {
	user: {},
};

const getters = {
	user(state) {
		return state.user;
	},
	userId(state) {
		return state.user.user_id;
	},
	userName(state) {
		return state.user.user_name;
	},
	userLevel(state) {
		return state.user.user_level;
	},
	// 로그인 여부
	isLogin(state) {
		return state.user.user_id !== '' && state.user.user_id !== undefined;
	},
	// 정회원 여부
	isRegularUser(state) {
		return (
			state.user.user_level &&
			parseInt(state.user.user_level) >= REGULAR_USER_LEVEL
		);
	},
};

const mutations = {
	// 로그인 후 회원 정보 저장
	setUser(state, user) {
		state.user = user || {};
	},
	// 회원 정보 수정에서 비밀번호 변경 시 사용
	setUserHp(state, userHp) {
		state.user.user_hp = userHp;
	},
	// 정회원 전환 시 사용
	setUserLevel(state, userLevel) {
		state.user.user_level = userLevel || ASSOCIATE_USER_LEVEL.toString();
	},
	// 로그아웃
	resetUser(state) {
		state.user = {};
	},
};

const actions = {
	userLogin({ commit }, payload) {
		return loginUser(payload)
			.then(({ data }) => {
				const { autoLogin } = payload;
				const { user, loginToken } = data;

				commit('setUser', user);

				// 자동 로그인 체크일 경우에만 로컬 스토리지에 저장한다.
				if (autoLogin) {
					setLoginToken(loginToken, autoLogin);
				}

				return data;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	userLogout({ commit }) {
		removeLoginToken();
		commit('resetUser');
	},
	getUserInfo({ commit }, payload) {
		return fetchUserFromLoginToken(payload)
			.then(({ data }) => {
				const { code, user } = data;

				if (code === '00000') {
					commit('setUser', user);
				}

				return data;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	updateUserLevelToRegular({ commit }, payload) {
		return updateToRegularUserLevel(payload)
			.then(response => {
				commit('setUserLevel', response.data.user_level);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
